export const ESTILOS = `
  * { box-sizing: border-box; margin: 0; padding: 0; }
  :root { --primary: #1d3d6b; --secondary: #0086ab; --accent: #3cafd6; }

  body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; }

  .app { display: flex; height: 100vh; overflow: hidden; background: #f3f6f9; }

  .sidebar { width: 240px; background: linear-gradient(180deg, #152d52 0%, #1b3a66 55%, #1d3d6b 100%); color: white; display: flex; flex-direction: column; overflow-y: auto; }
  .sidebar::-webkit-scrollbar { width: 3px; }
  .sidebar::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.2); }

  .sb-logo { padding: 20px 16px; background: rgba(0,0,0,0.2); font-size: 18px; font-weight: 700; letter-spacing: -0.02em; }
  .sb-logo span { color: var(--accent); }

  .sb-profile { display: flex; align-items: center; gap: 10px; padding: 14px 16px; border-bottom: 1px solid rgba(255,255,255,0.07); }
  .sb-avatar { width: 36px; height: 36px; border-radius: 50%; background: linear-gradient(135deg, var(--secondary), var(--accent)); display: flex; align-items: center; justify-content: center; color: white; font-weight: 700; flex-shrink: 0; box-shadow: 0 0 0 2px rgba(60,175,214,0.4); }
  .sb-pname { font-size: 12px; font-weight: 600; }
  .sb-prole { font-size: 10px; color: rgba(255,255,255,0.45); }

  .sb-nav { flex: 1; padding: 8px 0; }
  .sb-section { padding: 4px 0; }
  .sb-label { padding: 8px 16px 4px; font-size: 9px; color: rgba(255,255,255,0.4); text-transform: uppercase; letter-spacing: 0.1em; }

  .sb-item { display: flex; align-items: center; gap: 10px; padding: 9px 12px; margin: 0 8px 2px; cursor: pointer; color: rgba(255,255,255,0.6); font-size: 13px; transition: all 0.15s; border-radius: 8px; }
  .sb-item:hover { background: rgba(255,255,255,0.08); color: rgba(255,255,255,0.9); }
  .sb-item.active { background: rgba(60,175,214,0.18); color: white; box-shadow: inset 0 0 0 1px rgba(60,175,214,0.3); }
  .sb-item.active i { color: var(--accent); }
  .sb-item.open { background: rgba(255,255,255,0.05); }
  .sb-item i { font-size: 16px; flex-shrink: 0; }
  .sb-item .chev { margin-left: auto; font-size: 12px; transition: transform 0.2s; }
  .sb-item.open .chev { transform: rotate(180deg); }

  .submenu { max-height: 0; overflow: hidden; transition: max-height 0.22s ease; }
  .submenu.open { max-height: 500px; }

  .sub-item { display: flex; align-items: center; gap: 8px; padding: 7px 12px 7px 34px; margin: 0 8px 1px; cursor: pointer; color: rgba(255,255,255,0.5); font-size: 12px; transition: all 0.15s; border-radius: 6px; }
  .sub-item:hover { background: rgba(255,255,255,0.06); color: rgba(255,255,255,0.85); }
  .sub-item.active { color: var(--accent); background: rgba(60,175,214,0.12); }
  .sub-dot { width: 4px; height: 4px; border-radius: 50%; background: currentColor; opacity: 0.7; }

  .sb-footer { padding: 12px; border-top: 1px solid rgba(255,255,255,0.08); }
  .sb-logout { width: 100%; display: flex; align-items: center; gap: 10px; padding: 10px 12px; background: rgba(255,0,0,0.08); color: #ff6b6b; border: none; border-radius: 8px; cursor: pointer; font-size: 13px; transition: all 0.15s; }
  .sb-logout:hover { background: rgba(255,0,0,0.18); }

  .main { flex: 1; display: flex; flex-direction: column; overflow: hidden; }

  .topbar { background: white; border-bottom: 1px solid #e8ecf0; padding: 0 20px; height: 54px; display: flex; align-items: center; gap: 16px; flex-shrink: 0; box-shadow: 0 2px 8px rgba(0,0,0,0.06); }
  .breadcrumb { color: var(--primary); font-size: 13px; font-weight: 500; }
  .breadcrumb span { color: #9ca3af; }

  .hora-display { display: flex; flex-direction: column; align-items: flex-end; }
  .hora-valor { font-size: 14px; font-weight: 600; color: var(--primary); }
  .hora-label { font-size: 10px; color: #6b7280; }

  .search-wrap { display: flex; align-items: center; gap: 8px; background: #f3f6f9; border: 1px solid #e2e8f0; border-radius: 8px; padding: 6px 12px; width: 200px; }
  .search-wrap input { border: none; background: transparent; font-size: 13px; outline: none; width: 100%; }

  .tb-actions { display: flex; align-items: center; gap: 8px; }
  .ib { width: 34px; height: 34px; border-radius: 8px; display: flex; align-items: center; justify-content: center; cursor: pointer; color: #6b7280; font-size: 16px; transition: background 0.12s; position: relative; }
  .ib:hover { background: #f3f6f9; color: var(--primary); }
  .ndot { position: absolute; top: 7px; right: 7px; width: 6px; height: 6px; border-radius: 50%; background: #e24b4a; }
  .uav { width: 34px; height: 34px; border-radius: 50%; background: var(--secondary); display: flex; align-items: center; justify-content: center; color: white; font-size: 12px; font-weight: 600; cursor: pointer; }

  .content { flex: 1; overflow-y: auto; padding: 24px; }
  .content::-webkit-scrollbar { width: 4px; }
  .content::-webkit-scrollbar-thumb { background: #e2e8f0; border-radius: 4px; }

  .page-header { margin-bottom: 24px; display: flex; justify-content: space-between; align-items: center; }
  .page-title { font-size: 22px; font-weight: 700; color: var(--primary); letter-spacing: -0.02em; }
  .page-subtitle { font-size: 13px; color: #6b7280; margin-top: 3px; }

  .kpi-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 12px; margin-bottom: 24px; }
  .kpi { background: white; border: 1px solid #e8ecf0; border-radius: 10px; padding: 8px; border-left: 4px solid var(--accent); cursor: pointer; transition: all 0.18s; box-shadow: 0 2px 8px rgba(0,0,0,0.05); height: 50px; display: flex; flex-direction: column; justify-content: space-between; }
  .kpi:hover { border-left-color: var(--secondary); box-shadow: 0 6px 20px rgba(0,134,171,0.13); transform: translateY(-1px); }
  .kpi-label { font-size: 9px; color: #6b7280; margin-bottom: 2px; display: flex; align-items: center; gap: 3px; }
  .kpi-label i { font-size: 12px; }
  .kpi-val { font-size: 20px; font-weight: 700; color: var(--primary); letter-spacing: -0.03em; line-height: 1; }

  .card { background: white; border: 1px solid #e8ecf0; border-radius: 10px; padding: 16px; box-shadow: 0 2px 8px rgba(0,0,0,0.05); }
  .card-title { font-size: 13px; font-weight: 700; color: var(--primary); display: flex; align-items: center; gap: 6px; margin-bottom: 16px; }
  .card-title i { color: var(--secondary); }

  .section-grid { display: grid; grid-template-columns: 1fr; gap: 16px; margin-bottom: 24px; }

  .tabla { width: 100%; border-collapse: collapse; }
  .tabla thead { background: linear-gradient(90deg, var(--primary) 0%, #1a5a8a 100%); color: white; }
  .tabla th { padding: 12px; text-align: left; font-size: 12px; font-weight: 600; letter-spacing: 0.02em; }
  .tabla td { padding: 12px; border-bottom: 1px solid #e8ecf0; font-size: 12px; }
  .tabla tbody tr:nth-child(even) { background: #fafbfc; }
  .tabla tbody tr:hover { background: #eef6fb; }
  .tabla th.sortable { cursor: pointer; user-select: none; }
  .tabla th.sortable:hover { background: rgba(255,255,255,0.1); }

  .badge { display: inline-block; padding: 4px 10px; border-radius: 20px; font-size: 11px; font-weight: 600; }
  .badge-success { background: #d1fae5; color: #065f46; }
  .badge-danger { background: #fee2e2; color: #991b1b; }
  .badge-warning { background: #fef3c7; color: #92400e; }

  .modal-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 1000; }
  .modal { background: white; border-radius: 12px; width: 90%; max-width: 700px; max-height: 90vh; overflow-y: auto; box-shadow: 0 20px 60px rgba(0,0,0,0.3); border-top: 3px solid var(--secondary); }
  .modal-header { padding: 20px; border-bottom: 1px solid #e8ecf0; display: flex; justify-content: space-between; align-items: center; position: sticky; top: 0; background: white; }
  .modal-header h2 { color: var(--primary); font-size: 18px; }
  .modal-close { background: none; border: none; font-size: 24px; cursor: pointer; color: #6b7280; }

  .modal-tabs { display: flex; border-bottom: 1px solid #e8ecf0; }
  .modal-tab { flex: 1; padding: 14px; background: none; border: none; cursor: pointer; color: #6b7280; font-size: 13px; font-weight: 500; border-bottom: 2px solid transparent; transition: all 0.12s; }
  .modal-tab:hover { color: var(--primary); }
  .modal-tab.active { color: var(--primary); border-bottom-color: var(--primary); }

  .modal-body { padding: 24px; }
  .form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
  .form-group { display: flex; flex-direction: column; gap: 6px; }
  .form-group label { font-size: 12px; font-weight: 600; color: var(--primary); }
  .form-group input, .form-group select { padding: 8px 10px; border: 1px solid #d1d5db; border-radius: 6px; font-size: 12px; font-family: inherit; }
  .form-group input:focus, .form-group select:focus { outline: none; border-color: var(--secondary); box-shadow: 0 0 0 3px rgba(0,134,171,0.1); }

  .modal-footer { padding: 16px 24px; border-top: 1px solid #e8ecf0; display: flex; gap: 12px; justify-content: flex-end; background: #f9fafb; }

  .btn-primary { display: inline-flex; align-items: center; gap: 6px; padding: 8px 16px; background: linear-gradient(135deg, var(--secondary), #006f8e); color: white; border: none; border-radius: 6px; font-size: 12px; font-weight: 600; cursor: pointer; transition: all 0.15s; box-shadow: 0 2px 6px rgba(0,134,171,0.3); }
  .btn-primary:hover { background: linear-gradient(135deg, #006f8e, var(--primary)); box-shadow: 0 4px 12px rgba(0,134,171,0.35); transform: translateY(-1px); }
  .btn-primary:disabled { opacity: 0.6; cursor: not-allowed; transform: none; box-shadow: none; }

  .btn-secondary { padding: 8px 16px; background: #e5e7eb; color: #1f2937; border: none; border-radius: 6px; font-size: 12px; font-weight: 600; cursor: pointer; transition: all 0.12s; }
  .btn-secondary:hover { background: #d1d5db; }

  .btn-small { padding: 4px 12px; background: #10b981; color: white; border: none; border-radius: 4px; font-size: 11px; font-weight: 600; cursor: pointer; }
  .btn-small:hover { background: #059669; }
  .btn-small:disabled { opacity: 0.6; cursor: not-allowed; }
  .btn-small-warn { background: #f59e0b; }
  .btn-small-warn:hover { background: #d97706; }

  .login-screen { display: flex; align-items: center; justify-content: center; height: 100vh; background: linear-gradient(135deg, var(--primary) 0%, #0d5a8a 60%, var(--secondary) 100%); }
  .login-card { background: white; padding: 40px; border-radius: 16px; text-align: center; box-shadow: 0 24px 80px rgba(0,0,0,0.35); border-top: 4px solid var(--secondary); }
  .login-card h1 { color: var(--primary); font-size: 28px; font-weight: 700; letter-spacing: -0.03em; margin-bottom: 8px; }
  .login-card p { color: #6b7280; margin-bottom: 24px; }

  .btn-exp { background: none; border: 1px solid #d1d5db; border-radius: 6px; padding: 4px 8px; cursor: pointer; color: #0086ab; font-size: 14px; transition: all 0.12s; }
  .btn-exp:hover { background: #eff6ff; border-color: #0086ab; }

  .modal-exp { max-width: 800px; }

  .info-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
  .info-field { padding: 12px; background: #f9fafb; border-radius: 8px; border: 1px solid #e8ecf0; }
  .info-label { font-size: 10px; font-weight: 700; color: #6b7280; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 4px; }
  .info-valor { font-size: 14px; font-weight: 600; color: #1d3d6b; }

  .doc-btn { display: flex; align-items: center; gap: 10px; padding: 14px 16px; background: #eff6ff; color: #1d4ed8; border: 1px solid #bfdbfe; border-radius: 8px; font-size: 13px; font-weight: 600; cursor: pointer; transition: all 0.15s; width: 100%; box-shadow: 0 1px 4px rgba(0,0,0,0.06); }
  .doc-btn:hover:not(:disabled) { background: #dbeafe; transform: translateY(-1px); box-shadow: 0 4px 10px rgba(29,78,216,0.12); }
  .doc-btn i { font-size: 18px; }
  .doc-btn-outline { background: #f0fdf4; color: #166534; border-color: #bbf7d0; }
  .doc-btn-outline:hover:not(:disabled) { background: #dcfce7; }
  .doc-btn-danger { background: #fee2e2; color: #991b1b; border-color: #fca5a5; }
  .doc-btn-danger:hover:not(:disabled) { background: #fecaca; }
  .doc-btn-disabled { background: #f3f4f6; color: #9ca3af; border-color: #e5e7eb; cursor: not-allowed; }

  .accion-btn { display: inline-flex; align-items: center; gap: 7px; padding: 7px 14px; border-radius: 20px; border: 1px solid; font-family: inherit; cursor: pointer; transition: all 0.15s; font-size: 12px; font-weight: 600; white-space: nowrap; }
  .accion-btn i { font-size: 14px; }
  .accion-btn small { font-size: 10px; font-weight: 400; opacity: 0.65; margin-left: 2px; }
  .accion-btn-blue { background: #eff6ff; color: #1d4ed8; border-color: #bfdbfe; }
  .accion-btn-blue:hover { background: #dbeafe; }
  .accion-btn-green { background: #f0fdf4; color: #166534; border-color: #bbf7d0; }
  .accion-btn-green:hover { background: #dcfce7; }
  .accion-btn-red { background: #fee2e2; color: #991b1b; border-color: #fca5a5; }
  .accion-btn-red:hover { background: #fecaca; }
  .accion-btn-gray { background: #f9fafb; color: #374151; border-color: #d1d5db; }
  .accion-btn-gray:hover { background: #f3f4f6; }
  .accion-btn-disabled { background: #f3f4f6; color: #9ca3af; border-color: #e5e7eb; cursor: not-allowed; }

  .btn-danger { display: inline-flex; align-items: center; gap: 6px; padding: 8px 16px; background: #ef4444; color: white; border: none; border-radius: 6px; font-size: 12px; font-weight: 600; cursor: pointer; transition: all 0.12s; }
  .btn-danger:hover:not(:disabled) { background: #dc2626; }
  .btn-danger:disabled { opacity: 0.6; cursor: not-allowed; }

  /* Tab styles - Comedor format */
  .tabs-nav { display: flex; align-items: center; gap: 24px; border-bottom: 1px solid #e5e7eb; padding-bottom: 0; margin-bottom: 24px; }
  .tab-btn { background: none; border: none; padding: 12px 0; margin: 0; font-size: 14px; font-weight: 500; color: #6b7280; cursor: pointer; transition: all 0.2s; border-bottom: 2px solid transparent; display: flex; align-items: center; gap: 8px; position: relative; }
  .tab-btn i { font-size: 16px; }
  .tab-btn:hover { color: var(--primary); }
  .tab-btn.active { color: var(--secondary); border-bottom-color: var(--secondary); font-weight: 600; }

  @media (max-width: 768px) {
    .sidebar { width: 200px; }
    .kpi-grid { grid-template-columns: 1fr 1fr; }
    .section-grid { grid-template-columns: 1fr; }
    .info-grid { grid-template-columns: 1fr; }
  }
`;
